import { apiClient } from '~/services/api-service';

export const imagesMicrositeAPIService = {
  createImagesSite: (body) => {
    return apiClient.post(`/microsite/images/`, body);
  },
  replaceImagesSite: ({ id, body }) => {
    return apiClient.put(`/microsite/images/${id}/`, body);
  },
  updateImagesSite: ({ id, body }) => {
    return apiClient.patch(`/microsite/images/${id}/`, body);
  },
  addImage: (body) => {
    return apiClient.post(`/microsite/images-microsite/image/`, body);
  },
  removeImage: (id) => {
    return apiClient.delete(`/microsite/images-microsite/image/${id}/`);
  },
};
